"use client";

import { useEffect } from "react";

import { ANALYTICS_EVENTS, track } from "@/lib/analytics";

function referrerOf(raw: string): string | undefined {
  if (!raw) return undefined;
  try {
    const url = new URL(raw);
    return url.origin === window.location.origin ? url.pathname : url.hostname;
  } catch {
    return undefined;
  }
}

export function TrackNotFound() {
  useEffect(() => {
    track(ANALYTICS_EVENTS.NOT_FOUND, {
      path: window.location.pathname,
      referrer: referrerOf(document.referrer),
    });
  }, []);
  return null;
}
